import { render, staticRenderFns } from "./ProductEditWriteOff.vue?vue&type=template&id=c5b2f8e4"
import script from "./ProductEditWriteOff.vue?vue&type=script&lang=ts"
export * from "./ProductEditWriteOff.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c5b2f8e4')) {
      api.createRecord('c5b2f8e4', component.options)
    } else {
      api.reload('c5b2f8e4', component.options)
    }
    module.hot.accept("./ProductEditWriteOff.vue?vue&type=template&id=c5b2f8e4", function () {
      api.rerender('c5b2f8e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/ProductEditWriteOff.vue"
export default component.exports